module.exports = __webpack_public_path__ + "images/territory_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/territory_4.jpg
// module id = 58
// module chunks = 0